import { apiClient } from './agentService';

/**
 * Admin işlemleri için API service
 */
export const adminService = {
    // ═══════════════════════════════════════════════════════════
    // DASHBOARD
    // ═══════════════════════════════════════════════════════════

    getDashboardStats: async () => {
        const response = await apiClient.get('/dashboard/stats');
        return response.data;
    },

    /**
     * Tüm temsilcileri getirir (ADMIN only)
     */
    getAllAgents: async () => {
        const response = await apiClient.get('/agents');
        return response.data;
    },

    /**
     * Yeni temsilci oluşturur (ADMIN only)
     */
    createAgent: async (data) => {
        const response = await apiClient.post('/agents', data);
        return response.data;
    },

    /**
     * Mevcut kullanıcının profil bilgisini getirir
     */
    getProfile: async () => {
        const response = await apiClient.get('/agents/me');
        return response.data;
    },

    /**
     * Şifre değiştirir (AGENT)
     */
    changePassword: async (data) => {
        const response = await apiClient.put('/agents/change/password', data);
        return response.data;
    },

    /**
     * Temsilci siler (ADMIN only)
     */
    deleteAgent: async (userId) => {
        const response = await apiClient.delete(`/agents/${userId}`);
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // PROMPT YONETIMI
    // ═══════════════════════════════════════════════════════════

    /**
     * Tum prompt'lari getirir (ADMIN only)
     */
    getAllPrompts: async () => {
        const response = await apiClient.get('/prompts');
        return response.data;
    },

    /**
     * Aktif prompt'lari getirir (ADMIN only)
     */
    getActivePrompts: async () => {
        const response = await apiClient.get('/prompts/active');
        return response.data;
    },

    /**
     * Prompt gunceller (ADMIN only)
     */
    updatePrompt: async (key, promptText) => {
        const response = await apiClient.put(`/prompts/${key}`, { promptText });
        return response.data;
    },

    /**
     * Prompt cache'ini temizler (ADMIN only)
     */
    clearPromptCache: async () => {
        const response = await apiClient.post('/prompts/cache/clear');
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // BILGI KAZANI (KNOWLEDGE BASE) YONETIMI
    // ═══════════════════════════════════════════════════════════

    /**
     * Bilgi kazani kayitlarini sayfalanmis sekilde getirir (ADMIN only)
     */
    // search: terim BASLIK ve ICERIK icinde aranir (backend LOWER(..) LIKE)
    getAllKnowledgeBase: async (category, search, page = 0, size = 10) => {
        const params = new URLSearchParams();
        if (category) params.append('category', category);
        if (search) params.append('search', search);
        params.append('page', page);
        params.append('size', size);
        const response = await apiClient.get(`/knowledge-base?${params.toString()}`);
        return response.data;
    },

    /**
     * Benzersiz kategori listesini getirir (ADMIN only)
     */
    getKBCategories: async () => {
        const response = await apiClient.get('/knowledge-base/categories');
        return response.data;
    },

    /**
     * Aktif bilgi kazani kayitlarini getirir (ADMIN only)
     */
    getActiveKnowledgeBase: async () => {
        const response = await apiClient.get('/knowledge-base/active');
        return response.data;
    },

    /**
     * Yeni bilgi kazani kaydi olusturur (ADMIN only)
     */
    createKnowledgeBase: async (data) => {
        const response = await apiClient.post('/knowledge-base', data);
        return response.data;
    },

    /**
     * Bilgi kazani kaydini gunceller (ADMIN only)
     */
    updateKnowledgeBase: async (id, data) => {
        const response = await apiClient.put(`/knowledge-base/${id}`, data);
        return response.data;
    },

    /**
     * Bilgi kazani kaydini siler (ADMIN only)
     */
    deleteKnowledgeBase: async (id) => {
        const response = await apiClient.delete(`/knowledge-base/${id}`);
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // CEVAPLANAMAYAN SORULAR (UNANSWERED QUESTIONS) YONETIMI
    // ═══════════════════════════════════════════════════════════

    getUnansweredQuestions: async (status, page = 0, size = 10) => {
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        params.append('page', page);
        params.append('size', size);
        const response = await apiClient.get(`/unanswered-questions?${params.toString()}`);
        return response.data;
    },

    getUnansweredStats: async () => {
        const response = await apiClient.get('/unanswered-questions/stats');
        return response.data;
    },

    resolveUnansweredQuestion: async (id, adminNote) => {
        const response = await apiClient.put(`/unanswered-questions/${id}/resolve`, { adminNote });
        return response.data;
    },

    ignoreUnansweredQuestion: async (id) => {
        const response = await apiClient.put(`/unanswered-questions/${id}/ignore`);
        return response.data;
    },

    deleteUnansweredQuestion: async (id) => {
        const response = await apiClient.delete(`/unanswered-questions/${id}`);
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // GERI BILDIRIMLER (FEEDBACK) YONETIMI
    // ═══════════════════════════════════════════════════════════

    getFeedback: async (rating, page = 0, size = 10) => {
        const params = new URLSearchParams();
        if (rating) params.append('rating', rating);
        params.append('page', page);
        params.append('size', size);
        const response = await apiClient.get(`/feedback?${params.toString()}`);
        return response.data;
    },

    getFeedbackStats: async () => {
        const response = await apiClient.get('/feedback/stats');
        return response.data;
    },

    deleteFeedback: async (id) => {
        const response = await apiClient.delete(`/feedback/${id}`);
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // ONAY KAYITLARI (CONSENT RECORDS) YONETIMI
    // ═══════════════════════════════════════════════════════════

    getConsentRecords: async (consentType, startDate, endDate, search, page = 0, size = 10) => {
        const params = new URLSearchParams();
        if (consentType) params.append('consentType', consentType);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (search) params.append('search', search);
        params.append('page', page);
        params.append('size', size);
        const response = await apiClient.get(`/consent-records?${params.toString()}`);
        return response.data;
    },

    getConsentStats: async () => {
        const response = await apiClient.get('/consent-records/stats');
        return response.data;
    },

    // ═══════════════════════════════════════════════════════════
    // ARANACAK KULLANICILAR (CHAT LEADS)
    // ═══════════════════════════════════════════════════════════

    getLeads: async (status, search, startDate, endDate, unansweredOnly, page = 0, size = 10) => {
        const params = new URLSearchParams();
        if (status) params.append('status', status);
        if (search) params.append('search', search);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        if (unansweredOnly) params.append('unansweredOnly', 'true');
        params.append('page', page);
        params.append('size', size);
        const response = await apiClient.get(`/chat-leads?${params.toString()}`);
        return response.data;
    },

    getLeadStats: async () => {
        const response = await apiClient.get('/chat-leads/stats');
        return response.data;
    },

    generateLeadSummary: async (id, refresh = false) => {
        const response = await apiClient.post(`/chat-leads/${id}/summary${refresh ? '?refresh=true' : ''}`);
        return response.data;
    },

    getLeadMessages: async (id) => {
        const response = await apiClient.get(`/chat-leads/${id}/messages`);
        return response.data;
    },

    updateLeadStatus: async (id, callStatus, callNote) => {
        const response = await apiClient.put(`/chat-leads/${id}/status`, { callStatus, callNote });
        return response.data;
    },
};

export default adminService;
